import { RunInstanceEntityModel } from "src/store/models/entity/runInstance/entity";
import { RunInstanceHelperModel } from "src/store/models/entity/runInstance/helper";

export const encooRunInstanceModels = {
  entity: RunInstanceEntityModel,
  helper: RunInstanceHelperModel,
};
